// @ts-nocheck
import React from "react";
import { useQuery } from "react-query";
import genRequest from "includes/request";

import EditableUserImage from "components/User/Image/EditableUserImage";
import PasswordChangerForm from "components/Forms/PasswordChangerForm";
import ProfileForm from "components/Forms/ProfileChangerForm";
import "./ProfilePage.css";
import { t } from "i18next";
import { QueryTagsList } from "components/Tags/TagsList/TagsList";
import useAccount from "classes/Accounts/hooks/useAccount";
import useTemplate from "hooks/useTemplate";

// `groups/employee/:id` answers `groupName`/`groupDescription`; TagsList reads `name`/`description` (aliased once, here)
const treatGroups = (groups) =>
	(groups || []).map((g) => ({
		...g,
		name: g.groupName ?? g.name,
		description: g.groupDescription ?? g.description,
	}));

export default function ProfilePage() {
	const { account, isAdmin } = useAccount();
	const { template } = useTemplate();

	// Both `account` and `template` are populated asynchronously (and cleared
	// to null on logout). Guard explicitly so the unauth-after-logout
	// navigation doesn't blow up on `template.getAppFunction(...)` /
	// `account.employeeId`.
	const myEmployeeId = account?.employeeId;

	const fetchMe = () => genRequest("employees/" + myEmployeeId + "/complete");

	const { isLoading, data, error } = useQuery(
		["Employes", "GetCompleteEmpData", myEmployeeId],
		fetchMe,
		{ enabled: !!myEmployeeId }
	);

	if (!account || !template)
		return (<div>{t("Commons.LOADING")}</div>);

	if (isLoading)
		return (<div>{t("Commons.LOADING")}</div>);

	if (error)
		return (<div>{t("MyOnlyAll.PROFILE_ERROR")}</div>);

	let user = data?.employee;
	const canChangeProfile = template.getAppFunction(
		"ProfilePage.PersonalProfilPage.CanChangeProfil"
	);
	const canChangePassword = template.getAppFunction(
		"ProfilePage.PersonalProfilPage.CanChangePassword"
	);

	return (
		<div className="profile-cont d-block d-md-flex">
			<div className="d-flex flex-column me-3 mb-3">
				<div className="d-flex align-items-center justify-content-between flex-wrap">
					<div className="mb-3">
						<EditableUserImage user={user} employeeId={myEmployeeId} />
					</div>
					<div>
						<QueryTagsList
							className="mb-3"
							queryKey={["Groups", "GroupsOfEmploye", myEmployeeId]}
							queryFn={() => genRequest("groups/employee/" + myEmployeeId).then(treatGroups)}
							enabled={!!myEmployeeId}
						/>
					</div>
				</div>
				<ProfileForm
					editable={canChangeProfile}
					user={user}
					company={data?.company}
					site={data?.site}
					wfy={data?.wfy}
					wfu={data?.wfu}
				/>
			</div>
			{
				(canChangePassword !== false || isAdmin()) &&
				<PasswordChangerForm disabled={account.isTemp} disabledMsg={t("MyOnlyAll_Page.MyOnlyAll_Password_No_Change")} />
			}
		</div>
	);
}
